/**
 * Resolve a displayable face portrait URL from welcome / check-in payloads.
 */
export function resolveFacePortraitUrl(...sources) {
  for (const source of sources) {
    if (!source) continue;
    if (typeof source === 'string' && source.trim()) return source.trim();
    if (typeof source !== 'object') continue;
    const candidates = [
      source.captureUrl,
      source.face_image,
      source.faceImage,
      source.image,
      source.image_url,
      source.imageUrl,
      source.photo,
      source.photo_url,
      source.user?.image,
      source.user?.image_url,
      source.user?.captureUrl,
      source.profile?.image,
      source.profile?.image_url,
      source.customer_snapshot?.face_image,
      source.customer_snapshot?.captureUrl,
      source.customer_snapshot?.image,
    ];
    for (const value of candidates) {
      if (typeof value === 'string' && value.trim()) return value.trim();
    }
  }
  return '';
}

/**
 * Compress a data URL / blob URL into a small JPEG thumbnail for check-in cards.
 * @param {string} src
 * @param {{ maxWidth?: number, quality?: number }} [opts]
 * @returns {Promise<string|null>}
 */
export function compressFaceThumbnail(src, opts = {}) {
  const maxWidth = opts.maxWidth ?? 240;
  const quality = opts.quality ?? 0.72;
  if (!src || typeof src !== 'string') return Promise.resolve(null);

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      try {
        const scale = Math.min(1, maxWidth / Math.max(img.width, 1));
        const w = Math.max(1, Math.round(img.width * scale));
        const h = Math.max(1, Math.round(img.height * scale));
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          resolve(null);
          return;
        }
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL('image/jpeg', quality));
      } catch (_) {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
}
